// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { LoyaltyHeaderMenu } from '../../../../../common/constants';
import PreviewLoyaltyCard from './PreviewLoyaltyCard';
import PreviewGift from './PreviewGift';
import withLoyaltyConnect from '../WithLoyaltyConnect';
import Colours from '../../../../../styles/colours';
import MText from '../../../../../components/Common/MText';

const useStyles = makeStyles({
  previewContainer: {
    paddingBottom:               28,
    border:                      `1px solid ${Colours.Gray8}`,
    borderRadius:                12,
    '@media (min-width: 992px)': {
      paddingBottom: 36,
    },
    '@media (min-width: 1300px)': {
      paddingBottom: 64,
    },
  },
});

// eslint-disable-next-line max-len
export const PreviewNote = () => <MText className="mt-2 px-2" style={{ lineHeight: '0.9rem' }} text="NOTE: The logo displayed on the Loyalty Card is taken from your merchant page setup." />;

const Preview = (props) => {
  const classes = useStyles();
  return (
    <div className="mt-5 mb-3 container-fluid px-0">
      {
        props.tab !== LoyaltyHeaderMenu.Voucher ? (
          <div>
            <div className={`w-100 px-xl-3 pt-1 pt-lg-3 ${classes.previewContainer}`}>
              <PreviewLoyaltyCard
                containerClassname="mx-3 mx-xl-4"
              />
            </div>
          </div>
        ) : (
          <PreviewGift />
        )
      }
      <PreviewNote />
    </div>
  );
};

Preview.propTypes = {
  tab: PropTypes.oneOf([
    LoyaltyHeaderMenu.Design,
    LoyaltyHeaderMenu.Receipt,
    LoyaltyHeaderMenu.StampAndMechanics,
    LoyaltyHeaderMenu.Status,
    LoyaltyHeaderMenu.ValidityAndTerms,
    LoyaltyHeaderMenu.Voucher,
    LoyaltyHeaderMenu.Outlets,
  ]).isRequired,
};

export default withLoyaltyConnect(Preview);
